import { Point } from "./internal";
export function neq(p1, p2) {
    return p1.x !== p2.x || p1.y !== p2.y;
}
export function clone(p) {
    return new Point(p.x, p.y, p.index);
}
export function cross(a, b, c) {
    const acx = a.x - c.x, bcx = b.x - c.x, acy = a.y - c.y, bcy = b.y - c.y;
    return acx * bcy - acy * bcx;
}
export function edgeOrient(edge, point) {
    return cross(edge.p, edge.q, point);
}
export function edgeAbove(edge, point) {
    return cross(edge.p, edge.q, point) < 0;
}
export function edgeBelow(edge, point) {
    return cross(edge.p, edge.q, point) > 0;
}
// TODO: This is also in infra3d/infra3d.ts
export function isDefined(object) {
    return !(typeof object === "undefined");
}
//# sourceMappingURL=util.js.map